export default __webpack_public_path__ + "static/media/parallax-bg40.564292fb.jpg";